module.exports = __webpack_public_path__ + "img/copy.59055d1f.webp";